module.exports = __webpack_public_path__ + "static/hiveonasic-asic-white-239749c573c2b135f608870218211f07.svg";